var _learnq = window._learnq || [];

function addToCartEvent(newItem, custom_price) {
  let klAjax = true;

  fetchWithRetry(`${window.location.origin}/cart.js`, {}).then((res) =>
    res
      .clone()
      .json()
      .then((data) => {
        var cart = {
          total_price: Number(data.total_price / 100) + Number(data.total_discount / 100),
          $value: Number(data.total_price / 100) + Number(data.total_discount / 100),
          total_discount: data.total_discount,
          original_total_price: data.original_total_price / 100,
          items: data.items,
          customPrice: Number(custom_price),
        };
        if (item !== "undefined") {
          cart = Object.assign(cart, item);
        }
        if (klAjax) {
          _learnq.push(["track", "WD Added to Cart", cart]);
          klAjax = false;
        }
      })
  );
}
